import { useEffect, useState } from "react"
import { getAuth, onAuthStateChanged } from "firebase/auth"
import { doc, getDoc, getFirestore } from "firebase/firestore"
import { app } from "../firebase"
import { useNavigate } from "react-router-dom"

function VerificationStatus() {
    const auth = getAuth()
    const db = getFirestore(app)
    const navigate = useNavigate()

    const [isVerified, setIsVerified] = useState(true)
    const [loading, setLoading] = useState(true)

    useEffect(() => {
        const cached = JSON.parse(localStorage.getItem("profileData") || "{}")

        if (typeof cached.accountIsVerified === "boolean") {
            setIsVerified(cached.accountIsVerified)
            setLoading(false)
        }

        const unsubscribe = onAuthStateChanged(auth, async user => {
            if (!user) return

            const snap = await getDoc(doc(db, "users", user.uid))
            if (!snap.exists()) return

            const fresh = !!snap.data().accountIsVerified
            setIsVerified(fresh)
            setLoading(false)

            localStorage.setItem(
                "profileData",
                JSON.stringify({
                    ...cached,
                    accountIsVerified: fresh
                })
            )
        })

        return () => unsubscribe()


    }, [])

    if (loading || isVerified) return null

    return (
        <div className="alert alert-warning verificationDiv">
            Verify your account to start receiving ads and subscriptions.
            <button onClick={() => navigate("/verify-account")}>
                Start verification
            </button>
        </div>
    )
}

export default VerificationStatus